<template>
  <div class="schedule_detail">
    <div class="schedule-title">{{ this.$t("information.passenger") }}</div>
    <el-table
      :data="scheduleList"
      border
      style="width: 100%;"
      header-cell-class-name="header-row"
      :cell-style="{textAlign: 'center'}"
    >
      <el-table-column prop="dates" :label="$t('public.date')"></el-table-column>
      <el-table-column prop="times" :label="$t('public.time')"></el-table-column>
      <el-table-column prop="tips" :label="$t('public.tips')"></el-table-column>
    </el-table>
    <div class="schedule-title">{{ this.$t("information.commercial") }}</div>
    <el-table
      :data="subScheduleList"
      border
      style="width: 100%;"
      header-cell-class-name="header-row"
      :cell-style="{textAlign: 'center'}"
    >
    <el-table-column prop="dates" :label="$t('public.date')"></el-table-column>
      <el-table-column prop="times" :label="$t('public.time')"></el-table-column>
      <el-table-column prop="tips" :label="$t('public.tips')"></el-table-column>
    </el-table>
    <div class="schedule-title">{{ this.$t("information.culture") }}</div>
    <el-table
      :data="subScheduleList"
      border
      style="width: 100%;"
      header-cell-class-name="header-row"
      :cell-style="{textAlign: 'center'}"
    >
    <el-table-column prop="dates" :label="$t('public.date')"></el-table-column>
      <el-table-column prop="times" :label="$t('public.time')"></el-table-column>
      <el-table-column prop="tips" :label="$t('public.tips')"></el-table-column>
    </el-table>
    <!-- <div class="schedule-title">商用车</div>
    <el-table
      :data="subScheduleLists"
      border
      style="width: 100%;"
      header-cell-class-name="header-row"
      :cell-style="{textAlign: 'center'}"
    >
      <el-table-column prop="dates" label="日期"></el-table-column>
      <el-table-column prop="times" label="时间"></el-table-column>
      <el-table-column prop="tips" label="温馨提示"></el-table-column>
    </el-table> -->
  </div>
</template>

<script>
export default {
  data() {
    return {
      scheduleList: [
        {
          dates: this.$t("schedule.schedule1"),
          times: "9:00-17:30",
          tips: this.$t("schedule.mediaformedia")
        },
        {
          dates: this.$t("schedule.schedule2"),
          times: "9:00-17:30",
          tips: this.$t("schedule.propassenger")
        },
        {
          dates: this.$t("schedule.schedule3"),
          times: "9:00-17:30",
          tips: this.$t("schedule.normal")
        }
      ],
      subScheduleList:[
         {
          dates: this.$t("schedule.schedule4"),
          times: "9:00-17:30",
          tips: this.$t("schedule.mediaforvisitors")
        }
      ],
      subScheduleLists:[
         {
          dates: this.$t("schedule.schedule5"),
          times: "9:00-17:30",
          tips: this.$t("schedule.mediaforvisitors")
        }
      ]
    };
  }
};
</script>

<style lang="scss" scoped>
.schedule_detail {
  width: 100%;
  display: flex;
  justify-content: center;
    flex-direction: column;
    .schedule-title{
      font-size: 30px;
      margin: 50px 0px;
    }
  // margin: 60px 0px;
}

@media screen and (max-width: 1000px) {
  .schedule_detail {
    width: 100vw;
   
    > img {
      width: 100vw;
      height: auto;
    }
  }
}
</style>


// WEBPACK FOOTER //
// scedule.vue?2aa3d22f